export const PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = ['10', '20', '30'];
export const PAGE_TITLE = 'Learners Social Media';

export const searchStaticProps = {
  submitLabel: 'Search',
  resetLabel: 'Reset',
  inputPlaceholder: 'Enter the search term...',
  searchOptions: [
    {
      value: 'name',
      label: 'Name',
    },
    {
      value: 'learnerId',
      label: 'Learner',
    },
    {
      value: 'email',
      label: 'Email',
    },
  ],
};
